<ng-container *ngIf="worksheetItem.WorksheetType === worksheetType.Download">
  <!-- pdf -->
  <div class="card border margin-item">
    <div class="w-100 worksheet-image-height position-relative rounded">
      <img
        class="w-100 worksheet-image-height object-cover rounded-img"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />
    </div>
    <div class="fw-bold text-black p-2 font-size-20 position-relative mb-3 center-absolute w-100">
      {{ worksheetItem.Description || worksheetItem.Title }}
    </div>
    <div
      target="_blank"
      (click)="getDownload(worksheetId, worksheetItem.Id)"
      class="btn btn-primary text-capitalize bg-button text-white border-0 mt-5 p-2 m-2 fw-bold font-size-14"
    >
      {{ 'worksheet.download' | translate }}
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType === worksheetType.Gallery">
  <!-- image -->
  <div class="border-0 cursor-pointer mt-2 rounded p-2">
    <div (click)="openGalleryImage(galleryImage)">
      <img
        class="w-100 worksheet-image-height object-cover rounded"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />

      <div class="my-2 fw-bold">{{ worksheetItem.Description || worksheetItem.Title }}</div>
    </div>
  </div>

  <ng-template #galleryImage let-modal>
    <div class="modal-header justify-content-end">
      <span class="text-white cursor-pointer material-icons material-mobile-nav" (click)="modal.dismiss()">cancel</span>
    </div>
    <div class="modal-body">
      <img
        *ngIf="worksheetItem.Image"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        class="modal-image"
        [alt]="worksheetItem.Title"
        [@zoomAnimation]
      />
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType === worksheetType.ProviderVideo">
  <!-- video -->
  <div class="border-0 rounded">
    <div [ngSwitch]="worksheetItem.ProviderId">
      <ng-container *ngSwitchCase="providerName.Facebook">
        <fgb-facebook-player [streamKey]="worksheetItem.ProviderKey"></fgb-facebook-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.YouTube">
        <fgb-youtube-player [streamKey]="worksheetItem.ProviderKey"></fgb-youtube-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.StreamingVideoProvider">
        <fgb-svp-player [streamKey]="worksheetItem.ProviderKey"></fgb-svp-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Twitch">
        <fgb-twitch-player [streamKey]="worksheetItem.ProviderKey"></fgb-twitch-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Viemo">
        <fgb-vimeo-player [streamKey]="worksheetItem.ProviderKey"></fgb-vimeo-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Boxcast">
        <fgb-boxcast-player [streamKey]="worksheetItem.ProviderKey"></fgb-boxcast-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.Streamable">
        <fgb-streamable-player [streamKey]="worksheetItem.ProviderKey"></fgb-streamable-player>
      </ng-container>
      <ng-container *ngSwitchCase="providerName.StreamAMG">
        <!-- <fgb-amg-player [streamKey]="worksheetItem.ProviderKey"></fgb-amg-player> -->
        <fgb-stream-amg-player [streamKey]="worksheetItem.ProviderKey"></fgb-stream-amg-player>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="worksheetItem.WorksheetType === worksheetType.Link">
  <!-- link -->
  <div class="card border-0 my-3 rounded bg-transparent">
    <a target="_blank" [href]="worksheetItem.LinkUrl">
      <img
        class="w-100 worksheet-image-height object-cover rounded"
        [src]="worksheetItem.Image | contentImage : '6' : 'marketplace'"
        [alt]="worksheetItem.Title"
        [useDefault]="true"
        [loyaltyType]="'marketplace'"
        draggable="false"
      />

      <div class="mt-3 font-size-14 text-black">{{ worksheetItem.Description || worksheetItem.Title }}</div>
    </a>
  </div>
</ng-container>
